import post01 from './news-post1.json';
import post02 from './news-post2.json';
import post03 from './news-post3.json';

export const banner = {
  cover: 'https://img.alicdn.com/tfs/TB1ywawJXYqK1RjSZLeXXbXppXa-1920-627.png',
  mcover: 'https://gw.alicdn.com/tfs/TB1yDSbMZbpK1RjSZFyXXX_qFXa-750-320.png',
  title: '新闻动态',
};

export const news = [
  {
    pid: '1',
    title: '浙江省上线服务+监管一体化互联网医院平台',
    cover: 'https://gw.alicdn.com/tfs/TB1zzHEPgHqK1RjSZFPXXcwapXa-920-532.jpg',
    icon: 'https://gw.alicdn.com/tfs/TB1QHtENVYqK1RjSZLeXXbXppXa-74-74.png',
    class: 'icon-hospital',
    desc:
      '浙江省卫生健康委与阿里健康、支付宝筹备了半年多时间，在浙江省上线了该互联网医院平台，首创了服务+监管为一体的模式。',
    time: '2019-01-23 14:55',
    path: '/news?post=1',
  },
  {
    pid: '2',
    title: '浙江省居民电子健康卡——省中首发！',
    cover: 'https://gw.alicdn.com/tfs/TB12LfwPmzqK1RjSZPxXXc4tVXa-920-532.jpg',
    icon: 'https://gw.alicdn.com/tfs/TB1gy8vN6DpK1RjSZFrXXa78VXa-76-58.png',
    class: 'icon-ecard',
    desc:
      '浙江省居民电子健康卡是浙江省卫生健康委按照国家标准，为方便在我省医疗机构就诊的人民群众，实现跨机构和跨地域的线上线下一体化医疗健康服务而提供的电子卡。',
    time: '2018-10-26 17:04',
    path: '/news?post=2',
  },
  {
    pid: '3',
    title: '阿里健康联合支付宝实现全流程刷脸就医',
    cover: 'https://gw.alicdn.com/tfs/TB1T1zAPb2pK1RjSZFsXXaNlXXa-920-532.jpg',
    icon: 'https://gw.alicdn.com/tfs/TB1D0xFNVzqK1RjSZFoXXbfcXXa-66-66.png',
    class: 'icon-face',
    desc:
      '接下来，阿里健康与支付宝将在杭州上线就诊助手、院内导航、在线问医生等就医服务。阿里健康、支付宝、余杭一院三方历时半年，经过系统开发和联合调试，正式在余杭一院接入并且跑通了医保诊间结算。在试运行的一个半月内，“刷脸就医”超过1000笔，200位病人通过刷脸在院内完成了建档。',
    time: '2018-10-20 12:38',
    path: '/news?post=3',
  },
];

const postData = {
  post01,
  post02,
  post03,
};

export const newsData = {
  title: '新闻动态',
  subtitle: 'news information',
  extra: {
    title: '新闻列表',
    path: '/news',
  },
  path: '/news',
  news: news.map((item, idx) => {
    const postObj = postData[`post0${idx + 1}`];

    item.tags = postObj.tags;
    item.content = postObj.content;

    return item;
  }),
};
